import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { routes } from "../routes";
import PermissionRoute from "../../components/hoc/PermissionRoute";
import UserRequest from "./userRequests";
import { USER_ROLES } from "../../interfaces/roles";
import Sidebar from "./sideBar";
import AdminMainData from "./mainData";
import HomeAdmin from "./homeAdmin";
import ReportsTable from "./reportsTable";
import EmailSchedule from "./EmailSchedule";
import Email from "./Email";
import IntegrationsTable from "./ingredientsTable";
import CompaniesTable from "./CompaniesTable";
import UploadsTable from "./uploadTable";
import AdminBilling from "./billingTable";
import AdminRecommendations from "./adminRecommendations/adminRecommendations";
import AdminIngredients from "./adminIngredients/adminIngredients";
import Insights from "./insightAdmin";
import ToolAdmin from "./toolAdmin";
import JourneyAIAdmin from "./journeyAIAdmin";
import ToolLocking from "./toolLocking";
import TierMatrix from "./tierMatrix";
import shareProduct from "../account/company/components/shareProduct";
import { FaHome, FaUsers, FaCogs, FaDatabase, FaLightbulb, FaBrain, FaTools, FaLock, FaTable } from "react-icons/fa";
import { AdminViewModeProvider, useAdminViewMode } from "../../context/AdminViewModeContext";

const tabs = [
  { name: "Home",         route: routes.ADMIN_PRODUCTS,    icon: FaHome,      tabRoles: [USER_ROLES.ADMIN] },
  { name: "Customers",    route: routes.PENDING,            icon: FaUsers,     tabRoles: [USER_ROLES.ADMIN] },
  { name: "Company",      route: routes.ADMIN_COMPANIES,    icon: FaCogs,      tabRoles: [USER_ROLES.ADMIN] },
  { name: "Data",         route: routes.ADMIN_DATA,         icon: FaDatabase,  tabRoles: [USER_ROLES.ADMIN] },
  { name: "Tool Locking", route: routes.ADMIN_TOOL_LOCKING, icon: FaLock,      tabRoles: [USER_ROLES.ADMIN] },
  { name: "Tier Matrix",  route: routes.ADMIN_TIER_MATRIX,  icon: FaTable,     tabRoles: [USER_ROLES.ADMIN] },
  { name: "Billing",      route: routes.ADMIN_BILLING,      icon: FaDatabase,  tabRoles: [USER_ROLES.ADMIN] },
  { name: "Insights",     route: routes.ADMIN_INSIGHTS,     icon: FaLightbulb },
  { name: "Journey AI",   route: routes.ADMIN_JOURNEYAI,    icon: FaBrain },
  { name: "Tools",        route: routes.ADMIN_TOOLS,        icon: FaTools },
];

const AdminContent: React.FC = () => {
  const { viewMode, setViewMode } = useAdminViewMode();

  const toggleViewMode = () => {
    setViewMode(viewMode === 'expanded' ? 'compact' : 'expanded');
  };

  return (
    <div className={`admin-layout admin-layout--${viewMode}`}>
      <Sidebar
        tabs={tabs}
        userRole={USER_ROLES.ADMIN}
        viewMode={viewMode}
        onToggle={toggleViewMode}
      />
      <main className="admin-layout__content">
        <Switch>
          <PermissionRoute path={routes.PENDING}               component={UserRequest}          componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_DATA}            component={AdminMainData}         componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_PRODUCTS}        component={HomeAdmin}             componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_REPORTS}         component={ReportsTable}          componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_EMAIL_SCHEDULE}  component={EmailSchedule}         componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_EMAIL}           component={Email}                 componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_INTEGRATIONS}    component={IntegrationsTable}     componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_COMPANIES}       component={CompaniesTable}        componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_UPLOADS}         component={UploadsTable}          componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_BILLING}         component={AdminBilling}          componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_RECOMMENDATIONS} component={AdminRecommendations}  componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_INGREDIENTS}     component={AdminIngredients}      componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_SHARE_PRODUCTS}  component={shareProduct}          componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_INSIGHTS}        component={Insights}              componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_TOOLS}           component={ToolAdmin}             componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_JOURNEYAI}       component={JourneyAIAdmin}        componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_TOOL_LOCKING}    component={ToolLocking}           componentRoles={[USER_ROLES.ADMIN]} />
          <PermissionRoute path={routes.ADMIN_TIER_MATRIX}     component={TierMatrix}            componentRoles={[USER_ROLES.ADMIN]} />
          <Redirect to={routes.ADMIN_PRODUCTS} from="/" />
        </Switch>
      </main>
    </div>
  );
};

const AdminRouter: React.FC = () => (
  <AdminViewModeProvider>
    <AdminContent />
  </AdminViewModeProvider>
);

export default AdminRouter;
